import React from 'react';
import { tags } from '../tags';
import './tags.css';

export const BlogWebsiteTag = ({ tag }) => (
  <small className="tags__blogtag__container" style={tags[tag]}>
    {tag}
  </small>
);
